'use client'

import {
  navigateWizardRoute,
  useWizardNavigationState,
} from '@/components/_championship/forms/wizard-navigation/store'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { usePathname } from 'next/navigation'
import { useRouter } from 'nextjs-toploader/app'

export default function MobileDropdownNav({
  options,
  extraOptions = [],
  baseUrl,
  hasOutstandingApplications,
  useWizardNavigation = false,
}) {
  const pathname = usePathname()
  const router = useRouter()
  const { isNavigating } = useWizardNavigationState()
  const isNavigationLocked = useWizardNavigation ? isNavigating : false

  const handleNavigate = (value) => {
    if (isNavigationLocked) return
    if (!useWizardNavigation) {
      router.replace(`${baseUrl}/${value}`)
      return
    }
    void navigateWizardRoute({
      router,
      href: `${baseUrl}/${value}`,
      replace: true,
    })
  }

  return (
    <Select onValueChange={handleNavigate} disabled={isNavigationLocked}>
      <SelectTrigger>
        <div className="flex items-center gap-2 [&>svg]:size-4 [&>svg]:stroke-shades-0">
          {
            [...options, ...extraOptions].find((option) =>
              pathname.includes(option.urlSnippet),
            )?.icon
          }
          <p className="text-p-1 font-semibold">
            {
              [...options, ...extraOptions].find((option) =>
                pathname.includes(option.urlSnippet),
              )?.title
            }
          </p>
        </div>
      </SelectTrigger>
      <SelectContent>
        {[...options, ...extraOptions].map((option) => (
          <SelectItem key={option.title} value={option.urlSnippet}>
            <div className="relative flex items-center gap-2 [&>svg]:size-4 [&>svg]:stroke-shades-0">
              {option.icon}
              {option.title}
              {option.urlSnippet === 'applications' &&
                hasOutstandingApplications && (
                  <div className="absolute -right-4 top-0 h-3 w-3 rounded-full bg-orange-500"></div>
                )}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
